import * as React from "react";
const SvgFiRrAppleCore = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-apple-core_svg__a)">
      <path
        fill="#062147"
        d="M18 15.073c0-1.807.638-3.521 1.795-4.83.444-.5.629-1.16.508-1.81a2.05 2.05 0 0 0-1.085-1.456 8 8 0 0 0-1.97-.714c1.178-1.18 1.594-2.792 1.737-3.94A1.99 1.99 0 0 0 18.414.66a2 2 0 0 0-1.666-.571c-1.147.143-2.762.56-3.94 1.737a5 5 0 0 0-.667.826C11.514 1.174 10.766.399 10.71.344A.995.995 0 0 0 9.307.332a1.003 1.003 0 0 0-.022 1.41c.063.067 1.402 1.498 1.67 4.33H8.5a8.04 8.04 0 0 0-3.717.903A2.05 2.05 0 0 0 3.698 8.43c-.122.65.063 1.31.507 1.81C5.363 11.55 6 13.266 6 15.072c0 1.808-.638 3.523-1.795 4.83a2.13 2.13 0 0 0-.507 1.81 2.05 2.05 0 0 0 1.085 1.457 8 8 0 0 0 3.717.904c1.008 0 1.697-.341 2.25-.615.45-.224.776-.385 1.25-.385.556 0 .89.169 1.354.403.526.266 1.18.597 2.146.597a8.05 8.05 0 0 0 3.719-.904 2.06 2.06 0 0 0 1.084-1.458 2.12 2.12 0 0 0-.507-1.81C18.638 18.594 18 16.88 18 15.073M14.223 3.24c.776-.776 1.936-1.062 2.777-1.166v.004c-.104.836-.391 1.995-1.168 2.772-.782.782-1.95 1.066-2.777 1.168.102-.83.386-1.996 1.168-2.778m4.079 18.15a6.1 6.1 0 0 1-2.802.683c-.488 0-.805-.16-1.243-.382-.546-.275-1.225-.618-2.257-.618-.941 0-1.604.328-2.138.593-.46.228-.822.407-1.362.407a5.8 5.8 0 0 1-2.837-.73c-.003-.017-.006-.064.039-.115C7.184 19.555 8 17.368 8 15.073s-.816-4.481-2.3-6.157c-.043-.05-.04-.097 0-.161a6.05 6.05 0 0 1 2.8-.682h7c.98 0 1.925.229 2.837.728.003.019.006.065-.04.116-1.48 1.675-2.297 3.86-2.297 6.156s.816 4.48 2.299 6.155c.044.05.04.099.003.163"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-apple-core_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAppleCore;
